// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__Ch3sV","icon":"SubmitButton_icon__28Wsd","grow":"SubmitButton_grow__3Fusp"};